var map = {
	"./images/all-stage-locked.png": 1251,
	"./images/amulet_01.png": 1252,
	"./images/amulet_02.png": 1253,
	"./images/amulet_03.png": 1254,
	"./images/amulet_04.png": 1255,
	"./images/amulet_05.png": 1256,
	"./images/amulet_06.png": 1257,
	"./images/amulet_07.png": 1258,
	"./images/amulet_08.png": 1259,
	"./images/amulet_09.png": 1260,
	"./images/amulet_10.png": 1261,
	"./images/amulet_11.png": 1262,
	"./images/amulet_12.png": 1263,
	"./images/answer-a-pressed.png": 1264,
	"./images/answer-b-pressed.png": 1265,
	"./images/answer-buttions.png": 1266,
	"./images/answer-c-pressed.png": 1267,
	"./images/answer-correct.png": 1268,
	"./images/answer-wrong.png": 1269,
	"./images/attack-doubled.png": 1270,
	"./images/back.png": 1271,
	"./images/background.jpg": 1272,
	"./images/boos-question-start.png": 1273,
	"./images/boss-armor-red.png": 1274,
	"./images/boss-armor-yellow.png": 1275,
	"./images/boss-attack-boss.png": 1276,
	"./images/boss-attack-student.png": 1277,
	"./images/boss-back.png": 1278,
	"./images/boss-bar-red-01.png": 1279,
	"./images/boss-bar-red-02.png": 1280,
	"./images/boss-bar-red-03.png": 1281,
	"./images/boss-bar-red-04.png": 1282,
	"./images/boss-bar-red-05.png": 1283,
	"./images/boss-bar-red-06.png": 1284,
	"./images/boss-bar-red-07.png": 1285,
	"./images/boss-bar-red-08.png": 1286,
	"./images/boss-bar-red-09.png": 1287,
	"./images/boss-bar-red-10.png": 1288,
	"./images/boss-bar-red-11.png": 1289,
	"./images/boss-bar-yellow-01.png": 1290,
	"./images/boss-bar-yellow-02.png": 1291,
	"./images/boss-bar-yellow-03.png": 1292,
	"./images/boss-bar-yellow-04.png": 1293,
	"./images/boss-bar-yellow-05.png": 1294,
	"./images/boss-bar-yellow-06.png": 1295,
	"./images/boss-bar-yellow-07.png": 1296,
	"./images/boss-bar-yellow-08.png": 1297,
	"./images/boss-bar-yellow-09.png": 1298,
	"./images/boss-bar-yellow-10.png": 1299,
	"./images/boss-bar-yellow-11.png": 1300,
	"./images/boss-double-attack.png": 1301,
	"./images/boss-hidden-power-block-atk.png": 1302,
	"./images/boss-hidden-power-block-def.png": 1303,
	"./images/boss-hidden-power-block-hp.png": 1304,
	"./images/boss-hidden-power-block-not-select.png": 1305,
	"./images/boss-hidden-power-block.png": 1306,
	"./images/boss-item-block.png": 1307,
	"./images/boss-item-border.png": 1308,
	"./images/boss-item-empty.png": 1309,
	"./images/boss-number-red-0.png": 1310,
	"./images/boss-number-red-1.png": 1311,
	"./images/boss-number-red-2.png": 1312,
	"./images/boss-number-red-3.png": 1313,
	"./images/boss-number-red-4.png": 1314,
	"./images/boss-number-red-5.png": 1315,
	"./images/boss-number-red-6.png": 1316,
	"./images/boss-number-red-7.png": 1317,
	"./images/boss-number-red-8.png": 1318,
	"./images/boss-number-red-9.png": 1319,
	"./images/boss-number-yellow-0.png": 1320,
	"./images/boss-number-yellow-1.png": 1321,
	"./images/boss-number-yellow-2.png": 1322,
	"./images/boss-number-yellow-3.png": 1323,
	"./images/boss-number-yellow-4.png": 1324,
	"./images/boss-number-yellow-5.png": 1325,
	"./images/boss-number-yellow-6.png": 1326,
	"./images/boss-number-yellow-7.png": 1327,
	"./images/boss-number-yellow-8.png": 1328,
	"./images/boss-number-yellow-9.png": 1329,
	"./images/boss-remember-block.png": 1330,
	"./images/boss-student-bg.png": 1331,
	"./images/boss-tuagom-pic-starting.png": 1332,
	"./images/boss-tuagom-pic.png": 1333,
	"./images/broken-shield.png": 1334,
	"./images/cannot-access-dialog.png": 1335,
	"./images/coming-soon.png": 1336,
	"./images/full-locked.png": 1337,
	"./images/got-coin-10.png": 1338,
	"./images/half-locked.png": 1339,
	"./images/home copy.png": 1340,
	"./images/home.png": 1341,
	"./images/image-default-completed.png": 1342,
	"./images/image-default.png": 1343,
	"./images/lock copy.png": 1344,
	"./images/lock-dialog copy.png": 1345,
	"./images/lock-dialog.png": 1346,
	"./images/lock.png": 1347,
	"./images/lose.png": 1348,
	"./images/not-fighting-power.png": 1349,
	"./images/not-search-power.png": 1350,
	"./images/player-attacking.png": 1351,
	"./images/player-broken-shield.png": 1352,
	"./images/power-all1.png": 1353,
	"./images/power-all2.png": 1354,
	"./images/power-all3.png": 1355,
	"./images/power-all5.png": 1356,
	"./images/power-atk1.png": 1357,
	"./images/power-atk2.png": 1358,
	"./images/power-atk3.png": 1359,
	"./images/power-atk5.png": 1360,
	"./images/power-def1.png": 1361,
	"./images/power-def2.png": 1362,
	"./images/power-def3.png": 1363,
	"./images/power-def5.png": 1364,
	"./images/power-hp15.png": 1365,
	"./images/power-hp3.png": 1366,
	"./images/power-hp5.png": 1367,
	"./images/power-hp7.png": 1368,
	"./images/power-none.png": 1369,
	"./images/question-button-press-a.png": 1370,
	"./images/question-button-press-b.png": 1371,
	"./images/question-button-press-c.png": 1372,
	"./images/question-button.png": 1373,
	"./images/rank-a.png": 1374,
	"./images/rank-b.png": 1375,
	"./images/rank-c.png": 1376,
	"./images/rank-d.png": 1377,
	"./images/rank-e.png": 1378,
	"./images/rank-s.png": 1379,
	"./images/roll-dice-10.png": 1380,
	"./images/roll-dice-100.png": 1381,
	"./images/roll-dice-20.png": 1382,
	"./images/roll-dice-30.png": 1383,
	"./images/roll-dice-40.png": 1384,
	"./images/roll-dice-50.png": 1385,
	"./images/roll-dice-60.png": 1386,
	"./images/roll-dice-70.png": 1387,
	"./images/roll-dice-80.png": 1388,
	"./images/roll-dice-90.png": 1389,
	"./images/roll-dice-before.png": 1390,
	"./images/roll-dice.png": 1391,
	"./images/select copy.png": 1392,
	"./images/select.png": 1393,
	"./images/stage-locked.png": 1394,
	"./images/unselect copy.png": 1395,
	"./images/unselect.png": 1396,
	"./images/video-issue-point-ten.png": 1397,
	"./images/video-power-searching.png": 1398,
	"./images/video-yardnapha-issue-one.png": 1399,
	"./images/video-yardnapha-issue-two.png": 1400,
	"./images/video-yardnapha-issue.png": 1401,
	"./images/video-yardnapha-off.png": 1402,
	"./images/video-yardnapha-on.png": 1403,
	"./images/video-yardnapha-runoff.png": 1404,
	"./images/walk.png": 1405,
	"./images/win-normal-boss.png": 1406,
	"./images/win-reward-A01.png": 1407,
	"./images/win-reward-A02.png": 1408,
	"./images/win-reward-A03.png": 1409,
	"./images/win-reward-A04.png": 1410,
	"./images/win-reward-A05.png": 1411,
	"./images/win-reward-A06.png": 1412,
	"./images/win-reward-A07.png": 1413,
	"./images/win-reward-A08.png": 1414,
	"./images/win-reward-A09.png": 1415,
	"./images/win-reward-A10.png": 1416,
	"./images/win-reward-A11.png": 1417,
	"./images/win-reward-A12.png": 1418,
	"./images/win.png": 1419,
	"./images/yardnapha-avalible.png": 1420,
	"./images/yardnapha-got.png": 1421,
	"./images/yardnapha-gotten.png": 1422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1250;